import axios from 'axios';

export default {
  namespaced: true,
  state () {
    return {
      customerHomePage: null,
      proHomePage: null,
    };
  },
  getters: {
    customerHomePage (state) {
      return state.customerHomePage;
    },
    proHomePage (state) {
      return state.proHomePage;
    },

  },
  actions: {
    async fetchCustomerHomePage ({ commit }) {
      const { data } = await axios.get('/api/contentful/customer');
      commit('setCustomerHomePage', data);
    },
    async fetchProHomePage ({ commit }) {
      const { data } = await axios.get('/api/contentful/pro');
      commit('setProHomePage', data);
    },
  },
  mutations: {
    setCustomerHomePage (state, data) {
      state.customerHomePage = data;
    },
    resetCustomerHomePage (state) {
      state.customerHomePage = null;
    },
    setProHomePage (state, data) {
      state.proHomePage = data;
    },
    resetProHomePage (state) {
      state.proHomePage = null;
    },
  },
};
